const leftMenu = [
  {
    icon: 'feedback.svg',
    label: 'leftMenu.feedback',
    path: '/feedback'
  }
];
export default leftMenu;
